import { useAppSelector } from '@app/redux/hooks';
import { getAuthUserData } from '@app/entities/Auth';
import { useGetProfileQuery, getProfileTitle } from '@app/entities/User';

export const useUserProfile = () => {
  const { isLoggedin } = useAppSelector(getAuthUserData);
  const { data: profile = null, isLoading } = useGetProfileQuery(undefined, { skip: !isLoggedin });

  return {
    isLoggedin,
    isLoading,
    profile,
    profileTitle: getProfileTitle(isLoggedin, profile?.firstName, isLoading),
  };
};
